import { memo, type SVGProps } from "react";
import { cn } from "@/lib/utils";

type AppLogoIconProps = SVGProps<SVGSVGElement> & {
  name: string;
};

export default memo(function AppLogoIcon({
  name,
  className,
  ...props
}: AppLogoIconProps) {
  return (
    <svg
      className={cn("size-4", className)}
      type="image/svg+xml"
      viewBox="0 0 88 88"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{name}</title>
      <path d="M44 66c0 12.14-9.86 22-22 22h-1.76C9.06 88 0 78.94 0 67.76s9.06-20.24 20.24-20.24H44zm20.17-18.33C71.25 47.67 77 53.41 77 60.5s-5.74 12.83-12.83 12.83c-7.08 0-12.83-5.74-12.83-12.83 0-7.08 5.74-12.82 12.83-12.83M67.76 0C78.94 0 88 9.06 88 20.24s-9.06 20.24-20.24 20.24H44V22C44 9.86 53.86 0 66 0zM23.83 14.67c7.08 0 12.83 5.74 12.83 12.83s-5.74 12.83-12.83 12.83C16.75 40.33 11 34.59 11 27.5c0-7.08 5.74-12.82 12.83-12.83" />
    </svg>
  );
});
